import { Card, Image, Text } from '@fluentui/react-components';
import { PropsWithChildren, useMemo } from 'react';
import useSimpleLineCardStyles from './SimpleLineCard.styles';
import { ISimpleLineCardProps } from './SimpleLineCard.types';
import { Config } from '../../../../config';
import { PlanType } from '../../../../types/Plan';

const SimpleLineCard = (props: PropsWithChildren<ISimpleLineCardProps>) => {
    const { item, children } = props;

    const styles = useSimpleLineCardStyles();

    const image = useMemo(
        () => item.device?.image ?? `${Config.url.STORAGE_URL}/data/default-phone.svg`,
        [item.device?.image]
    );

    const lineName = useMemo(
        () => (item.byod ? 'Bring Your Own Device' : (item.device?.product.baseInfo.name ?? '')),
        [item.device?.product.baseInfo.name, item.byod]
    );

    const planName = useMemo(() => {
        let planType = '';
        switch (item.planSelection?.plan.planType) {
            case PlanType.UnlimitedData:
                planType = 'Unlimited Data';
                break;
            case PlanType.SharedData:
                planType = 'Shared Data';
                break;
            case PlanType.Prepaid:
                planType = 'Prepaid';
                break;
            case PlanType.HotspotData:
                planType = 'Hotspot Data';
                break;
            default:
        }

        return (
            <div>
                {item.planSelection && (
                    <Text block className={styles.linePlan}>
                        {item.planSelection.plan.name} {planType} Plan
                    </Text>
                )}
            </div>
        );
    }, [item.planSelection]);

    return (
        <>
            <Card className={styles.root}>
                <div className={styles.lineInfoContainer}>
                    {image && <Image key={image} alt={image} src={image} />}

                    <div>
                        <Text block className={styles.lineNumber}>
                            Line {item.lineNumber}
                        </Text>

                        <Text block className={styles.lineName}>
                            {lineName}
                        </Text>

                        {item.device?.colorName && item.device?.memoryOption && (
                            <Text block className={styles.lineDevice}>
                                {item.device.colorName}, {item.device.memoryOption}
                            </Text>
                        )}

                        {item.byod && (
                            <Text block className={styles.lineDevice}>
                                {item.byod.make} {item.byod.model}
                            </Text>
                        )}

                        {planName}
                    </div>
                </div>
                <div>{children}</div>
            </Card>
        </>
    );
};

export default SimpleLineCard;
